import api from './api'
import type { PaginatedResponse, TenantTag } from '@/types'
import type {
  ApiResponse,
  CreateTenantTagRequest,
  UpdateTenantTagRequest,
} from '@/types/api'

const TagsService = {
  async getAll(): Promise<TenantTag[]> {
    const response = await api.get<PaginatedResponse<TenantTag>>('/api/v1/tags')
    return response.data.data
  },

  async create(data: CreateTenantTagRequest): Promise<TenantTag> {
    const response = await api.post<ApiResponse<TenantTag>>('/api/v1/tags', data)
    return response.data.data
  },

  async update(tagId: string, data: UpdateTenantTagRequest): Promise<TenantTag> {
    const response = await api.put<ApiResponse<TenantTag>>(`/api/v1/tags/${tagId}`, data)
    return response.data.data
  },

  async delete(tagId: string): Promise<void> {
    await api.delete(`/api/v1/tags/${tagId}`)
  },
}

export default TagsService
